

































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import Doughnut from "./Doughnut.vue"
import Chart, { ChartData, ChartTooltipItem } from 'chart.js'
import { TranslatedFileModel } from '../../models/file.model';
import moment from 'moment';
import YesNoComponent, { YesNoCallback } from '@/components/YesNoComponent.vue';
import { env } from '@/env';

import { namespace } from "vuex-class";
const TranslationsStore = namespace("translations");
const TranslateStore = namespace("translate");

@Component({
  name: "StatsComponent",
  components: {
    Doughnut,
    YesNoComponent
  }
})
export default class StatsComponent extends Vue {
  private isGlobal = false;
  private showMessage = false;
  private showCountries = false;

  private documentCountPerLanguageData: Array<number> = [];
  private documentLanguagesLabels: Array<string> = [];
  private documentLanguagesColors: Array<string> = [];

  private documentCountPerDestinationLanguageData: Array<number> = [];
  private documentDestinationLanguagesLabels: Array<string> = [];
  private documentDestinationLanguagesColors: Array<string> = [];
  
  private documentCountPerSrcDestLanguageData: Array<number> = [];
  private documentSrcDestLanguagesLabels: Array<string> = [];
  private documentSrcDestLanguagesColors: Array<string> = [];
  
  private documentCountPerTypeData: Array<number> = [];
  private documentTypesLabels: Array<string> = [];
  private documentTypesColors: Array<string> = [];
  
  private documentCountPerCityData: Array<number> = [];
  private documentCitiesLabels: Array<string> = [];
  private documentCitiesColors: Array<string> = [];
  private documentCountPerCountryData: Array<number> = [];
  private documentCountriesLabels: Array<string> = [];
  private documentCountriesColors: Array<string> = [];
  private statusLabels: Array<string> = [];
  private statusDataOptions: Chart.ChartOptions = {};
  private statusColors: Array<string> = [];

  private pdfPerOcrProviderData: Array<number> = [];
  private docPerOcrProviderData: Array<number> = [];
  private jpgPerOcrProviderData: Array<number> = [];
  private pngPerOcrProviderData: Array<number> = [];
  private charsPerOcrProviderData: Array<number> = [];
  private ocrYesNoData: Array<number> = [];
  private sharedYesNoData: Array<number> = [];
  private statusData: Array<number> = [];

  private cityHeaders: any[];
  private countryHeaders: any[];
  private countryLocationsCount: any[] = [];
  private countriesCount: any[] = [];
  private pagination = {
    page: 1,
    pageCount: 0,
    itemsPerPage: 5
  };

  @TranslationsStore.Action
  public fetchTranslations!: (payload: any) => Promise<any>; //current user docs
  @TranslationsStore.Getter
  public getTranslatedDocuments!: TranslatedFileModel[];
  @TranslationsStore.Getter
  public isFetchingTranslations!: boolean;

  @TranslationsStore.Action
  public fetchAllDocuments!: () => Promise<any>; //all docs
  @TranslationsStore.Getter
  public getAllDocuments!: TranslatedFileModel[];
  @TranslationsStore.Getter
  public isFetchingAllTranslations!: boolean;

  @TranslateStore.Action
  public addFeedback!: (payload: any) => Promise<void>;

  private messageText = '';

  private currentDocuments: TranslatedFileModel[] = [];
  private currentDocumentsThisMonth: TranslatedFileModel[] = [];
  private currentDocumentsTotalChars = 0;
  private averageFileSize = 0;
  private readonly cognitiveColor = 'rgba(255, 165, 0, 0.8)';

  get pages(): number {
    if (
      this.pagination.itemsPerPage == null ||
      this.pagination.pageCount == null
    ) {
      return 0;
    } else {
      return Math.ceil(
        (this.pagination.pageCount === 0
          ? (this.showCountries ? this.documentCountriesLabels.length : this.documentCitiesLabels.length)
          : this.pagination.pageCount) / this.pagination.itemsPerPage
      );
    }
  }
  
  private yesNoCallback: YesNoCallback = (event: MouseEvent, isUseful: boolean, text: string, rating: number|null) => {
    event.stopPropagation();

    this.addFeedback({
      applicationId: env.environment, //NOTE: optional, can be used as subapp (upload/list/stats) or env (local, dev, uat, prod)
      url: window.location.href,
      text,
      isUseful,
      rating
    })
    .then(async () => {
      console.log("Yes/No Feedback added succesfully");
      //this.displayInfo("Yes/No Feedback added succesfully");
    })
    .catch(error =>{
      //this.displayError('Error adding Yes/No feedback, please contact us through the feedback section. Thanks');
      console.error(error, 'Error adding Yes/No feedback, please contact us through the feedback section. Thanks');
    })
    ;
  }

  constructor() {
    super();
    this.cityHeaders = [
      { text: "Country", value: "country", width: "40%"  },
      { text: "City", value: "city", width: "42%"  },
      { text: "Count", value: "count", width: "18%" },
    ];
    this.countryHeaders = [
      { text: "Country", value: "country", width: "82%"  },
      { text: "Count", value: "count", width: "18%" },
    ];
  }

  private async beforeMount() {
    this.isGlobal = (this.$route.query.mode == 'global');
    this.messageText = "Getting Stats";

    if(this.isGlobal) {
      await this.fetchAllDocuments()
      .then(() => {
        this.currentDocuments = this.getAllDocuments;
      })
      .catch((error: any) => {
        this.showMessage = true;
        console.error(
          "Error accessing Global stats, you are not authorized... Redirecting to User area",
          error
        );
        setTimeout(() => {
            //this.$router.push('/stats'); //not working to same route with different params
            window.location.replace("/stats");
        }, 2500);
      });
    } else {
      await this.fetchTranslations({ take: 100000 })
      .then(() => {
        this.currentDocuments = this.getTranslatedDocuments;
      })
      .catch((error: any) => {
        this.showMessage = true;
        console.error(
          "Error getting USER documents, please check your network connection",
          error
        );
      });
    }

    if(!this.currentDocuments || this.currentDocuments.length == 0)
      return;

    const pointRadiusDefault = this.isGlobal ? 2 : 3;

    //array sum
    const sum = (arr: any) : number => arr.reduce( (p: number, c: number) => p + c, 0 );
    //array average rounded to 2 decimals
    const average = (arr: any) : number => Math.round((Number.EPSILON + sum(arr) / arr.length) * 100) / 100;

    const finishedDocs = this.currentDocuments.filter((d:TranslatedFileModel)  => this.docIsFinished(d) );

    //METRICS
    const docsWithDate = this.currentDocuments.filter(d  => !this.isNullOrUndefined(d.dateTime));
    const now = new Date();
    const firstDayOfTheMonth = new Date(now.getFullYear(), now.getMonth(), 1, 0,0,0,0);
    this.currentDocumentsThisMonth = docsWithDate.filter(d => new Date(d.dateTime) >= firstDayOfTheMonth );
    this.currentDocumentsTotalChars = sum(finishedDocs.filter(d => d.totalCharacters).map(d=>d.totalCharacters));
    this.averageFileSize = average( finishedDocs.map(doc => Math.ceil(doc.totalBytes/1024) ) ) || 0;

    //TOTAL CHARS
    const filtered1 = this.currentDocuments.filter((d:TranslatedFileModel)  => d.totalCharacters && d.dateTime );
    const linedata1 = filtered1.map((d:TranslatedFileModel) => ({ x: new Date(d.dateTime) , y: d.totalCharacters, name: d.originalName }));
    //NOTE: not in kb because most of detected characters are 1 or 2 kb, and it is better to see total bytes.
    //const linedata1 = filtered1.map((d:TranslatedFileModel) => ({ x: new Date(d.dateTime) , y: Math.ceil(d.totalCharacters/1024) }));
    const chartData1: ChartData = {
      datasets: [
        {
          data: linedata1,
          backgroundColor: this.cognitiveColor,
          borderColor: this.cognitiveColor,
          label: "Total Chars",
          fill: false,
          pointRadius: pointRadiusDefault
        }
      ],
    };
    const config1: Chart.ChartConfiguration = {
      type: 'scatter',
      data: chartData1,
      options:  {
        legend: { display: false },
        scales: {
            xAxes: [{
                type: 'time',
                time: {
                    unit: 'month'
                }
            }]
        },
        tooltips: {
          callbacks: {
              label: function(tooltipItem: ChartTooltipItem, data: ChartData|any) {
                const docname = data.datasets[0].data[tooltipItem.index?? 0].name;
                const jsdate = new Date(tooltipItem.xLabel as string);
                const date = moment(jsdate).format('YYYY/MM/DD');
                return '(' + docname + ', ' + date + ', ' + tooltipItem.yLabel + ')';
              }
          }
        }
      }
    }
    const canvas1 = document.getElementById('totalchars') as HTMLCanvasElement;
    new Chart(canvas1, config1);

    //TOTAL KILO BYTES
    const filtered2 = this.currentDocuments.filter((d:TranslatedFileModel)  => d.totalBytes && d.dateTime );
    const linedata2 = filtered2.map((d:TranslatedFileModel) => ({ x: new Date(d.dateTime) , y: Math.ceil(d.totalBytes/1024), name: d.originalName }));

    const chartData2: ChartData = {
      datasets: [
        {
          data: linedata2,
          backgroundColor: "purple",
          borderColor: "purple",
          label: "Total KBytes",
          fill: false,
          pointRadius: pointRadiusDefault
        }
      ],
    };
    const config2 = { ...config1 };
    config2.data = chartData2;
    const canvas2 = document.getElementById('totalbytes') as HTMLCanvasElement;
    new Chart(canvas2, config2);

    //COUNTS
    const counts = (arr: any) => arr.reduce((acc: any, curr: string) => {
      if (typeof acc[curr] == 'undefined') {
        acc[curr] = 1;
      } else {
        acc[curr] += 1;
      }
      return acc;
    }, {});

    //SOURCE Language count
    const documentLanguages = this.currentDocuments.map(d => d.sourceLang && d.sourceLang.length > 0 ? d.sourceLang : 'unk');
    const langcounts = counts(documentLanguages);
    this.documentCountPerLanguageData = Object.values(langcounts);
    this.documentLanguagesLabels = Object.entries(langcounts)
      .map((el:any) => el[0] + ' [' + Math.round(100 * el[1]/documentLanguages.length) + '%]');
    //this.documentLanguagesLabels = Object.keys(langcounts);
    //this.documentLanguagesColors = this.documentLanguagesLabels.map((l:any,i:any) => this.dynamicColors());
    this.documentLanguagesColors = this.documentCountPerLanguageData.map(
      (cnt :any) => 'rgba(255, 102, 0, ' + (0.1 + cnt / Math.max(...this.documentCountPerLanguageData)) + ')' );

    //DEST Language count
    const documentDestinationLanguages = this.currentDocuments.map(d => 
      d.destinationLang && d.destinationLang.length > 0 ? d.destinationLang : 'unk');
    const dstlangcounts = counts(documentDestinationLanguages);
    this.documentCountPerDestinationLanguageData = Object.values(dstlangcounts);
    this.documentDestinationLanguagesLabels = Object.entries(dstlangcounts).map((el: any) => 
      el[0] + ' [' + Math.round(100 * el[1]/documentDestinationLanguages.length) + '%]');
    this.documentDestinationLanguagesColors = this.documentCountPerDestinationLanguageData.map(
      (cnt: any) => 'rgba(255, 102, 0, ' + (0.1 + cnt / Math.max(...this.documentCountPerDestinationLanguageData)) + ')' );

    //SRC-DEST Language count
    const documentSrcDestLanguages = this.currentDocuments.map(d =>
      (d.sourceLang && d.sourceLang.length > 0 ? d.sourceLang : 'unk') +
      '-' +
      (d.destinationLang && d.destinationLang.length > 0 ? d.destinationLang : 'unk')
    );
    const srcdstlangcounts = counts(documentSrcDestLanguages);
    this.documentCountPerSrcDestLanguageData = Object.values(srcdstlangcounts);
    this.documentSrcDestLanguagesLabels = Object.entries(srcdstlangcounts).map((el: any) => 
      el[0] + ' [' + Math.round(100 * el[1]/documentSrcDestLanguages.length) + '%]');
    this.documentSrcDestLanguagesColors = this.documentCountPerSrcDestLanguageData.map(
      (cnt: any) => 'rgba(255, 102, 0, ' + (0.1 + cnt / Math.max(...this.documentCountPerSrcDestLanguageData)) + ')' );

    //Documents by Type
    const filetype = (filename: any) => {
      if(this.isNullOrUndefined(filename)) {
        filename = '';
      }
      const a = filename.split(".");
      if( a.length === 1 || ( a[0] === "" && a.length === 2 ) ) { //no extension or hidden file
          return 'unk';
      }
      return a.pop().toLowerCase();
    }
    const documentTypes = this.currentDocuments.map(d => filetype(d.originalName) );
    const typecounts = counts(documentTypes);
    this.documentCountPerTypeData = Object.values(typecounts);
    this.documentTypesLabels = Object.entries(typecounts).map((el: any) => 
      el[0] + ' [' + Math.round(100 * el[1]/documentTypes.length) + '%]');
    this.documentTypesColors = this.documentCountPerTypeData.map(
      (cnt: any) => 'rgba(255, 102, 0, ' + (0.1 + cnt / Math.max(...this.documentCountPerTypeData)) + ')' );

    //City count
    const documentCities = this.currentDocuments.map(d => this.cityNormalized(d.city) ?? 'Other');
    const citycounts = counts(documentCities);
    this.documentCountPerCityData = Object.values(citycounts);
    this.documentCitiesLabels = Object.entries(citycounts)
      .map((el:any) => el[0] + ' [' + Math.round(100 * el[1]/documentCities.length) + '%]');
    this.documentCitiesColors = this.documentCountPerCityData.map(
      (cnt: any) => 'rgba(255,102,0,' + (0.1 + cnt / Math.max(...this.documentCountPerCityData)) + ')' );

    this.countryLocationsCount = Object.entries(citycounts).map((el: any) => {
      return {
        country: this.country(el[0].toLowerCase()) ?? 'Other',
        city: el[0],
        count: el[1]
      };
    });

    //Country count
    const documentCountries = this.currentDocuments.map(d => this.country(d.city) ?? 'Other');
    const countrycounts = counts(documentCountries);
    this.documentCountPerCountryData = Object.values(countrycounts);
    this.documentCountriesLabels = Object.entries(countrycounts)
      .map((el:any) => el[0] + ' [' + Math.round(100 * el[1]/documentCountries.length) + '%]');
    this.documentCountriesColors = this.documentCountPerCountryData.map(
      (cnt: any) => 'rgba(255,102,0,' + (0.1 + cnt / Math.max(...this.documentCountPerCountryData)) + ')' );

    this.countriesCount = Object.entries(countrycounts).map((el: any) => {
      return {
        country: el[0] ?? 'Other',
        count: el[1]
      };
    });

    //Doughnuts PDF
    const pdfDocs = this.currentDocuments.filter(doc => doc.model && doc.originalName?.toLowerCase().endsWith('pdf'));
    const pdfDocsDelta = pdfDocs.filter(doc => doc.model == 'delta');
    const pdfDocsCognitive = pdfDocs.filter(doc => doc.model == 'cognitive');
    this.pdfPerOcrProviderData = [pdfDocsCognitive.length, pdfDocsDelta.length];
    //Doughnuts Word
    const docDocs = this.currentDocuments.filter(doc => doc.model &&
      (doc.originalName?.toLowerCase().endsWith('doc') || doc.originalName?.toLowerCase().endsWith('docx')) );
    const docDocsDelta = docDocs.filter(doc => doc.model == 'delta');
    const docDocsCognitive = docDocs.filter(doc => doc.model == 'cognitive');
    this.docPerOcrProviderData = [docDocsCognitive.length, docDocsDelta.length];
    //Doughnuts JPG
    const jpgDocs = this.currentDocuments.filter(doc => doc.model &&
      (doc.originalName?.toLowerCase().endsWith('jpg') || doc.originalName?.toLowerCase().endsWith('jpeg')) );
    const jpgDocsDelta = jpgDocs.filter(doc => doc.model == 'delta');
    const jpgDocsCognitive = jpgDocs.filter(doc => doc.model == 'cognitive');
    this.jpgPerOcrProviderData = [jpgDocsCognitive.length, jpgDocsDelta.length];
    //Doughnuts PNG
    const pngDocs = this.currentDocuments.filter(doc => doc.model && doc.originalName?.toLowerCase().endsWith('png'));
    const pngDocsDelta = pngDocs.filter(doc => doc.model == 'delta');
    const pngDocsCognitive = pngDocs.filter(doc => doc.model == 'cognitive');
    this.pngPerOcrProviderData = [pngDocsCognitive.length, pngDocsDelta.length];


    //MULTIDOC
    const chartDataMultidoc: ChartData = {
      labels: [ "PDF", "Word", "JPG", "PNG" ],
      datasets: [
        //MS
        {
          label: "Cognitive",
          data: [ pdfDocsCognitive.length, docDocsCognitive.length, jpgDocsCognitive.length, pngDocsCognitive.length],
          backgroundColor: this.cognitiveColor,
          borderColor: this.cognitiveColor,
          //fill: false
        },
        //Delta
        {
          label: "Delta",
          data: [ pdfDocsDelta.length, docDocsDelta.length, jpgDocsDelta.length, pngDocsDelta.length],
          backgroundColor: "brown",
          borderColor: "brown",
        }
      ],
    };
    const configMultidoc: Chart.ChartConfiguration = {
      type: 'bar',
      data: chartDataMultidoc,
      options: { legend: { position: 'bottom' } }
    }
    const canvasMultidoc = document.getElementById('multidoc') as HTMLCanvasElement;
    new Chart(canvasMultidoc, configMultidoc);

    //STATUS
    const statComplete = this.currentDocuments.filter(d => this.statusDescriptionCollapsed(d.statusId) == 'Completed');
    const statProc = this.currentDocuments.filter(d => this.statusDescriptionCollapsed(d.statusId) == 'Processing');
    const statError = this.currentDocuments.filter(d => this.statusDescriptionCollapsed(d.statusId) == 'Error');
    this.statusData = [statComplete.length, statProc.length, statError.length]
    this.statusLabels = ['Ok', 'Processing', 'Error'];
    this.statusColors = [this.cognitiveColor, 'rgba(255, 165, 0, 0.3)', 'brown']
    const currdocs = this.currentDocuments;
    this.statusDataOptions =
    {
      legend: { position: 'bottom' },
      tooltips: {
        callbacks: {
            label: function(tooltipItem: ChartTooltipItem, data: ChartData|any) {
              const label = data.labels[tooltipItem.index ?? 0];
              const val = data.datasets[0].data[tooltipItem.index ?? 0];
              return label + ' [' + Math.round(100 * val/currdocs.length) + '%]: ' + val;
            }
        }
      }
    };

    //MULTIDATA
    const tsDocs = finishedDocs.filter(doc => doc.model == 'delta');
    const msDocs = finishedDocs.filter(doc => doc.model == 'cognitive');
    const tsDocsAvgRating = average( tsDocs.filter(d => !this.isNullOrUndefined(d.rating)).map(doc => doc.rating) );
    const msDocsAvgRating = average( msDocs.filter(d => !this.isNullOrUndefined(d.rating)).map(doc => doc.rating) );
    
    const chartDataMultidata: ChartData = {
      labels: [ "Rating" ],
      datasets: [
        //MS
        {
          label: "Cognitive",
          data: [ msDocsAvgRating ],
          backgroundColor: this.cognitiveColor,
          borderColor: this.cognitiveColor,
        },
        //Delta
        {
          label: "Delta",
          data: [ tsDocsAvgRating ],
          backgroundColor: "brown",
          borderColor: "brown",
        }
      ],
    };
    const configMultidata: Chart.ChartConfiguration = {
      type: 'bar',
      data: chartDataMultidata,
      options:  {
        scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
        }
      }
    }
    const canvasMultidata = document.getElementById('multidata') as HTMLCanvasElement;
    new Chart(canvasMultidata, configMultidata);

    //MONTHLYscatter
    const yearMonths2 = docsWithDate
      .map(d => new Date(new Date(d.dateTime).getFullYear(), new Date(d.dateTime).getMonth(), 1, 12, 0, 0, 0));
    const yearMonthsCounts2 = counts(yearMonths2);
    
    let docCountMonthlyData = Object.keys(yearMonthsCounts2).map(k => ({ x: new Date(k) , y: yearMonthsCounts2[k] }));
    docCountMonthlyData = docCountMonthlyData.sort((a,b) => a.x.getTime() - b.x.getTime());

    const chartDocCountMonthlyData: ChartData = {
      datasets: [
        {
          data: docCountMonthlyData,
          backgroundColor: "rgba(255, 165, 0, 0.5)",
          borderColor: "darkred",
          borderWidth: 1,
          label: "Document Count",
          fill: true,
          pointRadius: pointRadiusDefault,
          showLine: true,
          lineTension: 0
        }
      ],
    };
    const configDocCountMonthly: Chart.ChartConfiguration = {
      type: 'scatter',
      data: chartDocCountMonthlyData,
      options:  {
        legend: { display: false },
        scales: {
            xAxes: [{
              type:  'time',
              time: {
                  unit: 'month'
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
        },
        tooltips: {
          callbacks: {
              label: function(tooltipItem: ChartTooltipItem) {
                const jsdate = new Date(tooltipItem.xLabel as string);
                const date = moment(jsdate).format('YYYY/MMM');
                return '(' + date + ', ' + tooltipItem.yLabel + ')';
              }
          }
        }
      }
    };
    const canvasDocCountMonthly = document.getElementById('monthlyScatter') as HTMLCanvasElement;
    new Chart(canvasDocCountMonthly, configDocCountMonthly);


    //MULTIDATA2
    const tsDocsAvgTotalBytes = average( tsDocs.map(doc => Math.ceil(doc.totalBytes/1024) ) );
    const msDocsAvgTotalBytes = average( msDocs.map(doc => Math.ceil(doc.totalBytes/2014) ) );

    const chartDataMultidata2: ChartData = {
      labels: [ "KiloBytes" ],
      datasets: [
        //MS
        {
          label: "Cognitive",
          data: [ msDocsAvgTotalBytes ],
          backgroundColor: this.cognitiveColor,
          borderColor: this.cognitiveColor,
          //fill: false
        },
        //Delta
        {
          label: "Delta",
          data: [ tsDocsAvgTotalBytes ],
          backgroundColor: "brown",
          borderColor: "brown",
        }
      ],
    };
    const configMultidata2: Chart.ChartConfiguration = {
      type: 'bar',
      data: chartDataMultidata2,
      options:  {
        scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
        }
      }
    }
    const canvasMultidata2 = document.getElementById('multidata2') as HTMLCanvasElement;
    new Chart(canvasMultidata2, configMultidata2);

    //Doughnuts Translated Chars
    const tsDocsAvgTotalChars = average( tsDocs.map(doc => doc.totalCharacters) );
    const msDocsAvgTotalChars = average( msDocs.map(doc => doc.totalCharacters) );
    this.charsPerOcrProviderData = [ msDocsAvgTotalChars, tsDocsAvgTotalChars ];
    
    //Doughnuts OCR Yes No
    const ocrYes = finishedDocs.filter(doc => doc.isOcr === true ).length;
    const ocrNo = finishedDocs.length - ocrYes;
    this.ocrYesNoData = [ocrYes, ocrNo];
    
    //Doughnuts Shared Yes No
    const sharedYes = finishedDocs.filter(doc => doc.sharedWith && doc.sharedWith.length > 0).length;
    const sharedNo = finishedDocs.length - sharedYes;
    this.sharedYesNoData = [sharedYes, sharedNo];
  }
  private statusDescriptionCollapsed(statusId: number) : string {
    let ret = '';
    switch(statusId) {
      case  1:
        ret = 'Completed'; break;

      case -1:
      case 19:
      case 29:
      case 39:
        ret = 'Error'; break;

      default:
        ret = 'Processing'
    }
    return ret;
  }
  private statusDescription(statusId: number) : string {
    let ret = '';
    switch(statusId) {
      case -1: ret = 'Error'; break;
      case  0: ret = 'In Progress'; break;
      case  1: ret = 'Completed'; break;
      case 10: ret = 'OCR Queued'; break;
      case 11: ret = 'OCR In Progress'; break;
      case 19: ret = 'OCR Queue Error'; break;
      case 20: ret = 'Translate Queue'; break;
      case 21: ret = 'Translate In Progress'; break;
      case 29: ret = 'Translate Error'; break;
      case 31: ret = 'Retry In Progress'; break;
      case 39: ret = 'Retry Error'; break;
      default: ret = 'Unknown'
    }
    return ret;
  }

  private docIsFinished(doc: TranslatedFileModel) : boolean {
    return doc.statusId == 1; //COMPLETED
  }
  private isNullOrUndefined(v: any) : boolean {
    return v === null || v === undefined;
  }

  private cityNormalized(city: string | undefined): string|undefined {
    if(this.isNullOrUndefined(city))
      return city;
    else if(city?.trim().toLowerCase().startsWith('shanghai'))
      return "Shanghai";
    else
      return city;
  }
  private country(city: string | undefined) : string {
    //TODO: config in env.development (VUE_APP_LOCBYCOUNTRY), ignore case or even better key as regex...
    if(city !== undefined && city !== null) {
      city = city.toLowerCase().trim();
    }
    const LocationByCountry : { [key: string]: string; } = {
      "alger": "Algeria",
      "luanda": "Angola",
      "bahia blanca": "Argentina",
      "buenos aires": "Argentina", //not yet found, just in case
      "ciudad de buenos aires": "Argentina",
      "general deheza": "Argentina",
      "jujuy": "Argentina",
      "neuquen": "Argentina",
      "san juan": "Argentina",
      "san nicolas": "Argentina",
      "melbourne": "Australia",
      "sydney": "Australia",
      "graz": "Austria",
      "vienna": "Austria",
      "woergl": "Austria",
      "baku": "Azerbaijan",
      "dhaka": "Bangladesh",
      "antwerp": "Belgium",
      "antwerpen": "Belgium",
      "brussel": "Belgium",
      "brussels": "Belgium",
      "gembloux": "Belgium",
      "zelzate": "Belgium",
      "liège": "Belgium",
      "burgas": "Bulgaria",
      "sofia": "Bulgaria",
      "varna": "Bulgaria",
      "barueri": "Brazil",
      "piracema": "Brazil",
      "piracicaba": "Brazil",
      "rio de janeiro": "Brazil",
      "salvador": "Brazil",
      "santos": "Brazil",
      "sao bernardo do campo": "Brazil",
      "são bernardo do campo": "Brazil",
      "sao paulo": "Brazil",
      "são paulo": "Brazil",
      "ouagadougou": "Burkina Faso",
      "wahgnion": "Burkina Faso",
      "phnom penh": "Cambodia",
      "douala": "Cameroon",
      "blainville": "Canada",
      "calgary": "Canada",
      "edmonton": "Canada",
      "lakefield": "Canada",
      "mississauga": "Canada",
      "montreal": "Canada",
      "quebec": "Canada",
      "sarnia": "Canada",
      "antofagasta": "Chile",
      "santiago": "Chile",
      //China begin
      "aksu": "China",
      "beijing": "China",
      "changzhou": "China",
      "chongqing": "China",
      "dalian": "China",
      "fangchenggang": "China",
      "fuzhou": "China",
      "guangzhou": "China",
      "hangzhou": "China",
      "hong kong": "China",
      "nanjing": "China",
      "nantong": "China",
      "ningbo": "China",
      "qingdao": "China",
      "shanghai": "China",
      "shanghai-i": "China",
      "shanghai-l": "China",
      "shenzhen": "China",
      "shunde": "China",
      "suzhou": "China",
      "tianjin": "China",
      "tianjin-o": "China",
      "wuhan": "China",
      "xiamen": "China",
      //China end
      "barranquilla": "Colombia",
      "bogota": "Colombia",
      "bogota d.c.": "Colombia",
      "lubumbashi": "Congo",
      "pointe-noire": "Congo",
      "zagreb": "Croatia",
      "praha": "Czech Republic",
      "guayaquil": "Ecuador",
      "quito": "Ecuador",
      "alex": "Egypt",
      "cairo": "Egypt",
      "camberley": "England",
      "ellesmere port": "England",
      "immingham": "England",
      "leicester": "England",
      "lincolnshire": "England",
      "middlesbrough": "England",
      "milton keynes": "England",
      "oldbury": "England",
      "shepton mallet": "England",
      "tallinn": "Estonia",
      "helsinki": "Finland",
      "aix-en-provence": "France",
      "arcueil": "France",
      "evry": "France",
      "harfleur": "France",
      "marly": "France",
      "oignies": "France",
      "sete": "France",
      "st etienne du rouvray": "France",
      "st etienne du rouvray2": "France",
      "libreville": "Gabon",
      "port gentil": "Gabon",
      "poti": "Georgia",
      "suwanee": "Georgia",
      //Germany begin
      "bayreuth": "Germany",
      "berlin": "Germany",
      "dortmund": "Germany",
      "dresden": "Germany",
      "emstek": "Germany",
      "hamburg": "Germany",
      "herne": "Germany",
      "herten": "Germany",
      "muenchen": "Germany",
      "müenchen": "Germany",
      "munchen": "Germany",
      "münchen": "Germany",
      "speyer": "Germany",
      "sulzbach": "Germany",
      "taunusstein": "Germany",
      //Germany end
      "athens": "Greece",
      "escuintla": "Guatemala",
      "guatemala": "Guatemala",
      "guatemala city": "Guatemala",
      "conakry": "Guinea",
      "bissau": "Guinea-Bissau",
      "budapest": "Hungary",
      "nyiregyhaza": "Hungary",
      "chennai": "India",
      "gurgaon": "India",
      "hyderabad": "India",
      "manesar": "India",
      "mumbai": "India",
      "pune": "India",
      "bogor": "Indonesia",
      "jakarta": "Indonesia",
      "manado": "Indonesia",
      "bandarabbas": "Iran",
      "mahshahr": "Iran",
      "tehran": "Iran",
      "naas": "Ireland",
      //Italy begin
      "bari": "Italy",
      "cagliari": "Italy",
      "genova": "Italy",
      "livorno": "Italy",
      "milan": "Italy",
      "napoli": "Italy",
      "padova": "Italy",
      "ravenna": "Italy",
      "roma": "Italy",
      "siracusa": "Italy",
      "venezia": "Italy",
      //Italy end
      "abidjan": "Ivory Coast",
      "yokohama": "Japan",
      "osaka": "Japan",
      "amman": "Jordan",
      "almaty": "Kazakhstan",
      "balkhash": "Kazakhstan",
      "kostanay": "Kazakhstan",
      "temirtau": "Kazakhstan",
      "zhezkazgan": "Kazakhstan",
      "nairobi": "Kenya",
      "bishkek": "Kyrgyzstan",
      "riga": "Latvia",
      "ventspils": "Latvia",
      "beirut": "Lebanon",
      "klaipeda": "Lithuania",
      "andraharo": "Madagascar",
      "antananarivo": "Madagascar",
      "kuala lumpur": "Malaysia",
      "paka": "Malaysia",
      "shah alam s22": "Malaysia",
      "sa seksyen 22": "Malaysia",
      "bamako": "Mali",
      "maputo": "Mozambique",
      "yangon": "Myanmar",
      "cdmx": "Mexico",
      "naucalpan": "Mexico",
      "villahermosa": "Mexico",
      "chisinau": "Moldova",
      "casablanca": "Morocco",
      "mohammedia": "Morocco",
      "nacala": "Mozambique",
      "amsterdam": "Netherlands",
      "culemborg": "Netherlands",
      "heeswijk": "Netherlands",
      "roermond": "Netherlands",
      "schiphol": "Netherlands",
      "sittard": "Netherlands",
      "spijkenisse": "Netherlands",
      "voorburg": "Netherlands",
      "wellington": "New Zealand",
      "auckland": "New Zealand",
      "apapa": "Nigeria",
      "belfast": "Northern Ireland",
      "multan": "Pakistan",
      "karachi": "Pakistan",
      "panama": "Panama",
      "panama city": "Panama",
      "asuncion": "Paraguay",
      "callao": "Peru",
      "alabang": "Philippines",
      "makati": "Philippines",
      "manila": "Philippines",
      "biala podlaska": "Poland",
      "gdansk": "Poland",
      "gdynia": "Poland",
      "katowice": "Poland",
      "ozarow mazowiecki": "Poland",
      "pszczyna": "Poland",
      "warszawa": "Poland",
      "lisboa": "Portugal",
      "lisbon": "Portugal",
      "maia": "Portugal",
      "porto": "Portugal",
      "baneasa": "Romania",
      "bucharest": "Romania",
      "cluj napoca": "Romania",
      "constanta": "Romania",
      "ploiesti": "Romania",
      //Russia begin
      "arkhangelsk": "Russia",
      "chita": "Russia",
      "ekaterinburg": "Russia",
      "kaliningrad": "Russia",
      "kemerovo": "Russia",
      "krasnoyarsk": "Russia",
      "moscow": "Russia",
      "murmansk": "Russia",
      "nakhodka": "Russia",
      "novokuznetsk": "Russia",
      "novorossiysk": "Russia",
      "st-petersburg": "Russia",
      "tuapse": "Russia",
      "ust-luga": "Russia",
      "vanino": "Russia",
      "vyborg": "Russia",
      "vysotsk": "Russia",
      "yaroslavl": "Russia",
      //Russia end
      "dakar": "Senegal",
      "jubail": "Saudi Arabia",
      "beograd": "Serbia",
      "novi sad": "Serbia",
      "aberdeen": "Scotland",
      "singapore": "Singapore",
      "kosice": "Slovakia",
      "waterfall": "South Africa",
      "woodmead": "South Africa",
      "anyang": "South Korea",
      "gunpo": "South Korea",
      "pusan": "South Korea",
      "pyeoungtaek": "South Korea",
      "seoul": "South Korea",
      "ulsan": "South Korea",
      "yosu": "South Korea",
      //Spain begin
      "a coruna": "Spain",
      "almeria": "Spain",
      "badajoz": "Spain",
      "barcelona": "Spain",
      "bilbao": "Spain",
      "caceres": "Spain",
      "castellon": "Spain",
      "cordoba": "Spain",
      "coslada": "Spain",
      "durango": "Spain",
      "girona": "Spain",
      "granada": "Spain",
      "guadalajara": "Spain",
      "huelva": "Spain",
      "las palmas": "Spain",
      "madrid": "Spain",
      "málaga": "Spain",
      "malaga": "Spain",
      "murcia": "Spain",
      "palma de mallorca": "Spain",
      "pamplona": "Spain",
      "pasajes": "Spain",
      "paterna": "Spain",
      "puertollano": "Spain",
      "roces": "Spain",
      "sant cugat del valles": "Spain",
      "san sebastian": "Spain",
      "serra": "Spain",
      "sevilla": "Spain",
      "tarragona": "Spain",
      "tenerife": "Spain",
      "valencia": "Spain",
      "valladolid": "Spain",
      "vitoria": "Spain",
      "vizcaya": "Spain",
      "zamudio": "Spain",
      "zaragoza": "Spain",
      //Spain end
      "linkoping": "Sweden",
      "chiasso": "Switzerland",
      "geneva": "Switzerland",
      "zug": "Switzerland",
      "zurich": "Switzerland",
      "kaohsiung city": "Taiwan", //China?
      "new taipei city": "Taiwan", //China?
      "taichung city": "Taiwan", //China?
      "tainan city": "Taiwan", //China?
      "taipei": "Taiwan", //China?
      "bangkok": "Thailand",
      "tunis": "Tunisia",
      "ankara": "Turkey",
      "kocaeli": "Turkey",
      "istanbul": "Turkey",
      "izmir": "Turkey",
      "mersin": "Turkey",
      "ashgabat": "Turkmenistan",
      "turkmenbashi": "Turkmenistan",
      "san fernando": "Trinidad and Tobago",
      "kampala": "Uganda",
      "chornomorsk": "Ukraine",
      "dnepr": "Ukraine",
      "kiev": "Ukraine",
      "lviv": "Ukraine",
      "nikolayev": "Ukraine",
      "odessa": "Ukraine",
      "zaporozhye": "Ukraine",
      "dubai": "United Arab Emirates",
      "montevideo": "Uruguay",
      //USA begin
      "carson": "USA",
      "deer park": "USA",
      "east syracuse": "USA",
      "fairfield": "USA",
      "grass lake": "USA",
      "houston": "USA",
      "miami": "USA",
      "phoenix": "USA",
      "richardson": "USA",
      "rutherford": "USA",
      "the woodlands": "USA",
      //USA end
      "tashkent": "Uzbekistan",
      "can tho": "Vietnam",
      "ho chi minh city": "Vietnam",
      "hai phong": "Vietnam",
    };

    const country =  LocationByCountry[city ?? ''];
    // if(country === null || country === undefined) {
    //   console.error('loc->country [' + city + ']');
    //   this.missingCities[city ?? ''] = (this.missingCities[city ?? ''] ?? 0) + 1;
    // }

    return country;
  }
  // private missingCities: any = {};

  private dynamicColors() {
      var r = Math.floor(Math.random() * 255);
      var g = Math.floor(Math.random() * 255);
      var b = Math.floor(Math.random() * 255);
      return "rgb(" + r + "," + g + "," + b + ")";
  }
  get canShowDialog(): boolean {
    return this.isFetchingTranslations || this.isFetchingAllTranslations;
  }
}

